import { useStripePaymentElements } from 'webReservations/checkout/useStripePaymentElements';
import { useMutation } from '@tanstack/react-query';

export const useProcessStripeIntent = () => {
  const { processPaymentIntent, processSetupIntent } =
    useStripePaymentElements();

  return useMutation({
    mutationFn: async ({
      paymentIntentClientSecret,
      setupIntentClientSecret,
    }: {
      paymentIntentClientSecret?: string;
      setupIntentClientSecret?: string;
    }) => {
      if (paymentIntentClientSecret) {
        await processPaymentIntent(paymentIntentClientSecret);
      } else if (setupIntentClientSecret) {
        await processSetupIntent(setupIntentClientSecret);
      }
    },
  });
};
